module.exports = __webpack_public_path__ + "img/file-search-01.904d747c.svg";